import React, { Component } from 'react';

import { View, TextInput } from 'react-native';

import Loading from './loading';
import ButtonIcon from './buttonIcon';
import styles from './styles';

export default class SearchInput extends Component {
    render() {
        const { onChange, onClean, title, query } = this.props;

        return (
            <View style={[this.props.style, styles.content]}>
                <TextInput
                    autoFocus={false}
                    style={styles.input}
                    placeholder={title}
                    onChangeText={(q) => onChange(q)}
                    value={query}
                    ref="inputSearch"
                />

                <Loading />

                <ButtonIcon onPress={onClean} query={query} />
            </View>
        );
    }
}
